//utils
import { buildComputedForm } from "@u/methods";
import { ValidObj } from "@u/model";
import { rex_value, rex_email, rex_password } from "@u/regex";
function formObj(_this) {
  return {
    name: {
      ...new ValidObj(""),
      key: "name",
      label: "姓名",
      placeholder: (label) => _this.$tp("please.enter", { label }),
      valid: [
        { regex: rex_value, warn: (label) => _this.$tp("please.enter", { label }) }
      ]
    },
    email: {
      ...new ValidObj(""),
      key: "email",
      label: "Email",
      placeholder: (label) => _this.$tp("please.enter", { label }),
      valid: [
        { regex: rex_value, warn: (label) => _this.$tp("please.enter", { label }) },
        { regex: rex_email, warn: (label) => _this.$tp("slot.formatError", { label }) },
      ]
    },
    phoneNum: {
      ...new ValidObj(""),
      key: "phoneNum",
      label: "電話",
      placeholder: (label) => _this.$tp("please.enter", { label }),
      valid: [
        { regex: rex_value, warn: (label) => _this.$tp("please.enter", { label }) }
      ]
    }
  }
}
export default {
  data() {
    return {
      form: formObj(this)
    }
  },
  computed: {
    ...buildComputedForm(formObj())
  }
}